import Header from './Header'
import Footer from './Footer'

export default function Layout({ children }) {
  return (
    <div className="wc-theme min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  )
}
